import { apiFetch } from './client';
import type { Paginated, Product } from '$lib/types';

function toQuery(params: Record<string, string | number | undefined> = {}): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== '') search.set(key, String(value));
  }
  const s = search.toString();
  return s ? `?${s}` : '';
}

export const productsApi = {
  list: (params?: { q?: string; page?: number; per_page?: number }) =>
    apiFetch<Paginated<Product>>(`/products${toQuery(params)}`),
  upsert: (body: { name: string; part_number?: string; category?: string }) =>
    apiFetch<Product>('/products/upsert', { method: 'POST', body: JSON.stringify(body) })
};
